import { SVGProps } from 'react';

const Partner = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M17.758 6.884 15.312 5.18a1 1 0 0 0-.571-.18h-3.996a1 1 0 0 0-.707.293l-1.59 1.59H2.75a.75.75 0 0 0 0 1.5h4.197A.843.843 0 0 0 7 9.624l.647.548a2.75 2.75 0 0 0 3.721-.154l1.076-1.077 5.875 5.875a.25.25 0 0 1-.004.357l-.133.129a.255.255 0 0 1-.354-.006l-3.932-3.932-1.06 1.06 3.396 3.397-.289.285a.25.25 0 0 1-.352-.002l-3.272-3.271-1.06 1.06 2.462 2.463-.438.38a.25.25 0 0 1-.34-.012l-2.414-2.412-1.06 1.06 1.1 1.099a1.248 1.248 0 0 1-1.265-.282l-2.007-1.932H2.75a.75.75 0 1 0 0 1.5h3.94l1.572 1.513a2.747 2.747 0 0 0 3.417.312l.202.202a1.75 1.75 0 0 0 2.385.084l.546-.474a1.75 1.75 0 0 0 2.182-.218l.418-.412a1.75 1.75 0 0 0 1.808-.38l.135-.13a1.74 1.74 0 0 0 .53-1.383h1.228a.75.75 0 0 0 0-1.5h-2.118l-5.19-5.19a1 1 0 0 0-.707-.292h-1.309a1 1 0 0 0-.707.293l-.775.775a1.25 1.25 0 0 1-1.692.07l-.103-.087 2.44-2.439h3.632l2.51 1.749.192.135h3.827a.75.75 0 0 0 0-1.5h-3.355Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Partner;
